import React from 'react';
import { Button } from '@mui/material';
import theme from './../../theme';

const CommonButtonComponent = ({ children,onClick,sx, ...props }) => {
  const buttonBackground = theme?.button?.backgroundColor?.main ?? theme.palette.primary.main;
  const buttonText = theme?.button?.textColor?.main ?? theme.palette.primary.contrastText;
  return (
    <Button   
      onClick={onClick}         
      variant="contained"
      sx={{
        mt: 3,
        mb: 2,
        background: buttonBackground,
        color: buttonText,
        textTransform:'none',
        fontWeight: "700",
        
        border: `1px solid ${buttonBackground}`,
        '&:hover': {
          backgroundColor: "transparent",
          color: buttonBackground,
        },
        ...sx, 
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CommonButtonComponent;
